<template>
<path fill-rule="evenodd" d="M68.926.865C59.048.642 19.48.912 9.366 11.301-4.758 25.806-4.504 54.258 21.855 60.784c24.214 5.995 55.452 8.621 67.08 8.883 7.593.172 46.905-2.032 61.683-12.577 10.38-7.406 10.26-20.568-.327-35.876C139.846 4.365 75.612 1.016 68.926.865z"/>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// components/_SVG/ShapeYearBtn3Tab.vue